import { observer } from "mobx-react";
import React from "react";
import { ContactType } from "../../api/firebase/types/contact.types";
import ContactStore from "../../store/ContactStore";
import GenericPickList from "./GenericPickList";

type ContactPickListProps = {
  onChange: (contactIds: string[]) => void;
  selectedContactIds: string[];
};

const ContactPickList: React.FC<ContactPickListProps> = (props) => {
  const { contacts } = ContactStore;
  return (
    <GenericPickList<ContactType>
      className="p-m-2"
      showSourceControls={false}
      showTargetControls={false}
      filterBy="firstName,lastName"
      sourceFilterPlaceholder="Suche nach Namen..."
      targetFilterPlaceholder="Suche nach Namen..."
      options={contacts}
      selectedOptionIds={props.selectedContactIds}
      onChange={(contacts) =>
        props.onChange(contacts.map((contact) => contact.id))
      }
      itemTemplate={(contact: ContactType) => (
        <div>{`${contact.firstName} ${contact.lastName}`}</div>
      )}
    />
  );
};
export default observer(ContactPickList);
